import React, { useState, useEffect } from 'react';
import '../styles/SeatMap.css';
import RoomSVG from './RoomSVG';
import type { Group, RoomData, SeatChild, SeatNode, SeatToGuestMap, Guest, TableChild } from '../types';
import { updateSeatStates } from '../utils/updateSeatStates';

interface SeatMapProps {
  roomData: RoomData | null;
  seatToGuestMap: SeatToGuestMap;
  guestCodes?: Guest[];
  onSeatClick?: (seat: SeatNode | SeatChild) => void;
  onTableClick?: (table: TableChild) => void;
}

const SeatMap: React.FC<SeatMapProps> = ({ roomData, seatToGuestMap, guestCodes, onSeatClick, onTableClick }) => {
  const [groups, setGroups] = useState<Group[]>(roomData?.groups || []);
  const [zoomToTableId, setZoomToTableId] = useState<string | null>(null);

  useEffect(() => {
    if (roomData) {
      setGroups(roomData.groups || []);
    }
  }, [roomData]);

  // Update seat states (CSS classes) when seatToGuestMap or guestCodes change
  useEffect(() => {
    updateSeatStates(seatToGuestMap, guestCodes);
  }, [seatToGuestMap, guestCodes]);

  const handleSeatClick = (seat: SeatNode | SeatChild) => {
    if (onSeatClick) {
      onSeatClick(seat);
    }
  };

  const handleTableClick = (table: TableChild) => {
    if (onTableClick) {
      onTableClick(table);
    }
    setZoomToTableId(table.guid || table.tableId || table.id || null);
  };

  return (
    <div className="seatmap-zoom-area" style={{ width: '100%', height: '100%', overflow: 'auto' }} tabIndex={0}>
      <div
        style={{ width: '100%', height: '100%' }}
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            pointerEvents: 'auto',
          }}
        >
          <RoomSVG
            groups={groups}
            seatToGuestMap={seatToGuestMap}
            guestCodes={guestCodes}
            handleSeatClick={handleSeatClick}
            handleTableClick={handleTableClick}
            zoomToTableId={zoomToTableId}
          />
        </div>
      </div>
    </div>
  );
};

export default SeatMap;
